module.exports = __webpack_public_path__ + "static/media/up-user-details-background.84295f2e.jpg";